export default __webpack_public_path__ + "static/media/gift.35b35ec3.png";